import { HttpParams } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  IELAsyncAutocompleteElement,
  SELECTION_MODE,
} from '@el-async-autocomplete';
import { TranslateService } from '@ngx-translate/core';

import { FilesService } from '../../../../services/files.service';
import { FilteredConnectionIdentitiesWithRolesDTO } from '../../../connections/services/connections.service';
import { IdentitiesService } from '../../../identities/services/identities.service';
import { IFilterData } from '../../../messages/popups/create-thread/create-thread.component';

@Component({
  selector: 'app-re-assign-handler',
  templateUrl: './re-assign-handler.component.html',
  styleUrls: ['./re-assign-handler.component.scss'],
})
export class ReAssignHandlerComponent {
  readOnly = false;

  SELECTION_MODE = SELECTION_MODE;
  isLoadedAvatars = false;
  accountHandlerMarkAsTouched = false;
  isAccountHandlerLoadedAvatars = false;
  totalAccountHandlerUsers = 0;
  accountHandlerUsersListForAsyncAutoComplete: IELAsyncAutocompleteElement[] =
    [];
  selectedAccountHandlerUserValues: IELAsyncAutocompleteElement = null;

  form = new FormGroup({
    agent: new FormControl(undefined, [Validators.required]),
  });

  constructor(
    public translate: TranslateService,
    private readonly filesService: FilesService,
    private readonly identitiesService: IdentitiesService,
    private matDialog: MatDialogRef<ReAssignHandlerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      accountHandlerId?: string;
      claimHandlerId?: string;
      isClaimHandler?: boolean;
    }
  ) {
    if (data) {
      this.form.controls.agent.setValue(
        data?.isClaimHandler ? data.claimHandlerId : data.accountHandlerId
      );
      this.onFilterUsers(null, this.form.controls.agent.value);
    }
  }

  selectAccountHandlerUser(
    e: IELAsyncAutocompleteElement | IELAsyncAutocompleteElement[]
  ) {
    if ('key' in e) this.form.controls.agent.setValue(e.key?.toString());
  }

  private async formatUser(
    user: FilteredConnectionIdentitiesWithRolesDTO
  ): Promise<IELAsyncAutocompleteElement> {
    return user
      ? {
          key: user.identity._id,
          value: `${user.role_name}::${user.identity.first_name} ${
            user.identity.last_name || ''
          }`,
          avatar: await this.filesService.getProfilePictureOneTime(
            user.identity
          ),
        }
      : null;
  }

  private async formatUsers(
    users: FilteredConnectionIdentitiesWithRolesDTO[]
  ): Promise<IELAsyncAutocompleteElement[]> {
    return Promise.all(users.map((user) => this.formatUser(user)));
  }

  onFilterUsers(eventData: IFilterData, _id?: string) {
    let httpParams = new HttpParams();

    httpParams = _id
      ? httpParams.append('_id', _id)
      : (httpParams = httpParams
          .append('name', eventData.event)
          .append('start', eventData.start)
          .append('size', eventData.size));

    this.identitiesService
      .getConnectionByAgents(httpParams)
      .subscribe(async (data_all_users) => {
        if (_id) {
          const user = data_all_users?.data?.find(
            (d) => d?.identity?._id?.toString() === _id?.toString()
          );

          this.selectedAccountHandlerUserValues = await this.formatUser(user);
        } else {
          this.accountHandlerUsersListForAsyncAutoComplete =
            eventData.type === 'scroll'
              ? this.accountHandlerUsersListForAsyncAutoComplete.concat(
                  await this.formatUsers(data_all_users.data)
                )
              : await this.formatUsers(data_all_users.data);
        }
      });
  }

  isRequired(abstractControl: FormControl<any>) {
    return abstractControl.hasValidator(Validators.required);
  }

  onCancel(): void {
    this.matDialog.close();
  }

  onSave() {
    if (this.form.valid) {
      this.matDialog.close({
        agent: this.form.value.agent,
      });
    }
  }
}
